import { useAppSelector } from "../../../store/hooks";
import ToothSelectorOld from "./ToothSelectorOld";
import ToothSelectorNew from "./ToothSelectorNew";

const ToothSelector = (props: any) => {
  const { user } = useAppSelector((state) => state.auth);
  if (user?.role === "Super Admin" || user?.token === "TM") {
    return <ToothSelectorNew {...props} />;
  }
  return <ToothSelectorOld {...props} />;
};

export default ToothSelector;
